import { render, staticRenderFns } from "./QuoteBooking.vue?vue&type=template&id=ece6f782&scoped=true"
import script from "./QuoteBooking.vue?vue&type=script&lang=js"
export * from "./QuoteBooking.vue?vue&type=script&lang=js"
import style0 from "./QuoteBooking.vue?vue&type=style&index=0&id=ece6f782&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ece6f782",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ece6f782')) {
      api.createRecord('ece6f782', component.options)
    } else {
      api.reload('ece6f782', component.options)
    }
    module.hot.accept("./QuoteBooking.vue?vue&type=template&id=ece6f782&scoped=true", function () {
      api.rerender('ece6f782', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/quote/components/QuoteHeader/QuoteBooking.vue"
export default component.exports